export const getTargetPosition = (
    elementIndex,
    gap,
    nbOfProductCards,
    index,
    minHitsLength,
) => {
    if (elementIndex === null) {
        return null;
    }
    return nbOfProductCards <= minHitsLength && index === nbOfProductCards
        ? nbOfProductCards + 1
        : gap * (elementIndex + 1);
};

export const getGap = (
    nbOfProductCards,
    elementsLength,
    maxPercentageOfInGridElements,
) => {
    if (elementsLength <= 0) return null;
    let newElementsLength = elementsLength;
    if (
        (elementsLength / nbOfProductCards) * 100 >
        maxPercentageOfInGridElements
    ) {
        newElementsLength = Math.floor(
            nbOfProductCards / (maxPercentageOfInGridElements - 1),
        );
    }

    return Math.floor(nbOfProductCards / (newElementsLength + 1));
};

export const getElementIndex = (elementsLength, index, gap) => {
    if (!gap) {
        return null;
    }
    const newIndex = Math.floor(index / gap - 1);
    if (elementsLength === 1) return 0;
    if (elementsLength < newIndex) return null;
    return newIndex;
};
